import { supabase } from '../lib/supabase'

export async function logError(error: any, context?: any) {
    const msg = error instanceof Error ? error.message : (typeof error === 'string' ? error : JSON.stringify(error))
    const stack = error instanceof Error ? error.stack : null
    
    console.log('🚀 INTENTANDO REGISTRAR LOG EN DB:', msg)

    try {
        const { data: { session } } = await supabase.auth.getSession()
        const userId = session?.user?.id
        
        // Verificación de salud
        let agency_id = context?.agency_id || (window as any)._agencyId
        
        if (!agency_id && userId) {
            const { data: profile } = await supabase.from('agency_users').select('agency_id').eq('user_id', userId).maybeSingle()
            agency_id = profile?.agency_id
        }

        const { error: insErr } = await supabase.from('crm_errors').insert({
            agency_id,
            user_id: userId,
            level: context?.level || 'error',
            message: msg,
            details: { 
                stack, 
                url: window.location.href,
                ...context 
            },
            context: context?.component || 'Global'
        })

        if (insErr) console.error('❌ FALLO INSERCIÓN LOG:', insErr.message)
        else console.log('✅ LOG GUARDADO CON ÉXITO')
    } catch (e) {
        console.warn('Silent fail recording log:', e)
    }
}

// Capturador automático para errores no capturados
export function initGlobalLogging(agencyId?: string) {
    if (agencyId) (window as any)._agencyId = agencyId
    
    // 1. Capturar errores fatales de JS
    window.onerror = (message, source, lineno, colno, error) => {
        logError(error || message, { component: 'AutoGlobal', source, lineno, colno })
    }

    // 2. Capturar promesas fallidas
    window.onunhandledrejection = (event) => {
        logError(event.reason, { component: 'PromiseRejection' })
    }

    // 3. INTERCEPTAR CONSOLE.ERROR (Para capturar los cuadros naranjas)
    const originalConsoleError = console.error
    console.error = (...args: any[]) => {
        // Mostrar en consola original para no perder la visualización
        originalConsoleError.apply(console, args)
        
        // Evitar bucles infinitos si logError falla
        const msg = args.map(arg => typeof arg === 'object' ? JSON.stringify(arg) : String(arg)).join(' ')
        if (!msg.includes('Logging to DB') && !msg.includes('FALLO INSERCIÓN LOG')) {
            logError(msg, { component: 'ConsoleIntercept' })
        }
    }

    console.log('🛡️ SISTEMA DE AUDITORÍA GLOBAL ACTIVADO')
}
